import { render, staticRenderFns } from "./RentalForm.vue?vue&type=template&id=5a9d7a3a"
import script from "./RentalForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./RentalForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports